import { useContext } from 'react'

import dialogContext from 'contexts/dialogContext'

function useDialog () {
  return useContext(dialogContext)
}

export default useDialog
